import {useGuestGroup} from 'hooks/useGuestGroup';

function useCanShareRegistration() {
  const {guestGroup} = useGuestGroup();

  return (guestGroup?.known_number_of_guests ?? 0) > 1;
}

export {useCanShareRegistration};
